import {Link} from 'react-router-dom'
import Button from 'lib/ui/Button'
import React from 'react'
import {useEvent} from 'Event/EventProvider'
import {CustomPurchasePage} from 'Event/Marketplace/custom-purchase-page'

const marketplaceStoreUrl = process.env.REACT_APP_MARKETPLACE_STORE_APP_URL

export default function CustomPurchasePreviewButton(props: {
  customPurchasePage: CustomPurchasePage
}) {
  const {event} = useEvent()

  return (
    <Link
      to={{
        pathname: `${marketplaceStoreUrl}/${event.slug}/preview/purchase_page/${props.customPurchasePage.slug}`,
      }}
      target="_blank"
    >
      <Button
        variant="contained"
        color="primary"
        size="small"
        aria-label="preview button"
      >
        Preview &gt;
      </Button>
    </Link>
  )
}
